import { Component, Input, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { Globals } from 'src/app/globals';
import { RegUser } from 'src/app/pages/basic-reg/RegUser';
import moment from 'moment';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-add-family-member',
  templateUrl: './add-family-member.component.html',
  styleUrls: ['./add-family-member.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    NgxIntlTelInputModule
  ]
})
export class AddFamilyMemberComponent implements OnInit {

  @Input("type") type: number = 0;
  @Input("memberId") memberId: any = '';
  currentUser = {};

  separateDialCode = false;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.India];

  relationList: any[] = [];
  dateValidation: boolean = false;
  dob: any = '';

  isValidPoneNumber: boolean = false;
  phoneMessage: string = '';
  internationalPhoneNo: any = '';
  mobileNoViewInEdit: any = '';

  requestPath: string = this.global.requestPath;

  signupForm!: FormGroup;
  signupInput: RegUser = new RegUser();
  submitted: boolean = false;

  errorMessage: string = '';

  heading: string = '';
  subheading: string = '';
  btnText: string = '';

  selectedMobilNo: any = '';

  emailPattern: string = "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";
  passwordVisible: boolean = false;

  roles = [{
    "name": "Viewer",
    "value": 4
  }, {
    "name": "Admin",
    "value": 5
  }];

  intlOptions = {
    initialCountry: 'us',
    autoHideDialCode: true,
    separateDialCode: false,
    enableAutoCountrySelect: true,
    autoPlaceholder: 'polite',
    nationalMode: true,
    customPlaceholder: function (selectedCountryPlaceholder: any) {
      return 'Example : ' + selectedCountryPlaceholder;
    }
  }

  constructor(
    public modalCtrl: ModalController,
    @Inject(Globals) private global: Globals,
    private authService: AuthServiceService,
    private formBuilder: FormBuilder,
    private loader: LoaderService
  ) { }

  ngOnInit(): void {
    this.getRelationList();

    this.signupForm = this.formBuilder.group({
      firstName: ['', [Validators.required, this.noWhitespace, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, this.noWhitespace, Validators.maxLength(50)]],
      emailAddress: ['', [Validators.required, this.noWhitespace, Validators.maxLength(50), Validators.pattern(this.emailPattern)]],
      userPassword: ['', [Validators.required, Validators.minLength(6)]],
      relation: ['', Validators.required],
      phoneNumber: ['', [Validators.required]],
      birthDate: ['', [Validators.required]],
      role: ['', [Validators.required]]
    });
  }

  ionViewDidEnter() {
    this.passwordVisible = false;
    this.resetPhoneNumber();
    this.fetchUser();
    this.initUser();

    if (this.type == 1) {

      // Add Case
      this.heading = "Add Member";
      this.subheading = "Fill in the form below to add a member";
      this.btnText = "Add";

      this.enableEmailPhonenumber();

    } else if (this.type == 2) {

      // Edit Case
      this.heading = "Edit Member";
      this.subheading = "Update the data of the member";
      this.btnText = "Update";

      this.disableEmailPhonenumber();

      this.fetchUserData();

    } else {
      this.authService.unauthorized();
    }
  }

  resetPhoneNumber = () => {
    this.mobileNoViewInEdit = null;
    this.selectedMobilNo = null;
    this.signupInput.phoneNumberAll = null;
    this.signupInput.phoneDialCode = "1";
    this.signupInput.phoneCountryShortName = "us";
    this.isValidPoneNumber = false;
    this.phoneMessage = '';
    // currentUser; // removed stray statement
  }

  fetchUser = () => {
    this.currentUser = this.authService.getLoggedInUser();
  }

  initUser = () => {
    this.signupInput = new RegUser();
    this.submitted = false;
    this.signupForm.reset();
  }

  fetchUserData = () => {
    this.errorMessage = "";

    this.loader.show("Loading data...");
    this.authService.get('user?' + this.requestPath + '=getUserMemberById&memberId=' + this.memberId)
      .subscribe((res: any) => {
        this.loader.hide();
        //console.log(res);
        if (res && res.success) {
          this.signupInput = this.global.decrypt(res.data);
          this.signupInput.birthDate = this.formatBirthDateForDisplay(this.signupInput.birthDate);
          this.mobileNoViewInEdit = this.getPhoneForEditView(this.signupInput);
          this.patchFormWithSignupInput();
        } else {
          this.errorMessage = res?.message || '';
        }
      }, (error: any) => {
        this.loader.hide();
        //console.log(error);
        this.errorMessage = "Some error occured, please try again!!!";
      });
  }

  getRelationList = () => {
    this.relationList = [];
    this.loader.show("Loading data...");
    this.authService.getNoSecure('ns/refData?' + this.requestPath + '=findAllByParentId&parentId=' + 8)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res && res.success) {
          //console.log(res);
          this.relationList = this.global.decryptDefault(res.data);
        }
      }, (error: any) => {
        this.loader.hide();
        //console.log(error);
      });
  }

  disableEmailPhonenumber() {
    this.signupForm.controls["emailAddress"].disable();
    this.signupForm.controls["phoneNumber"].disable();
  }

  enableEmailPhonenumber() {
    this.signupForm.controls["emailAddress"].enable();
    this.signupForm.controls["phoneNumber"].enable();
  }

  public noWhitespace(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'required': true }
  }

  get f() { return this.signupForm.controls; }

  async dismiss(data: any) {
    this.modalCtrl.dismiss(data);
  }

  onDateChange(birthDate: any): void {

    if (this.global.isEmpty(birthDate)) {
      this.dateValidation = false;
      this.signupForm.controls['birthDate'].setErrors(null);
      return;
    }

    if ((birthDate as string).length < 10) {
      this.dateValidation = false;
      this.signupForm.controls['birthDate'].setErrors(null);
      return;
    }

    const parsedDob = moment(birthDate, ['MM/DD/YYYY', moment.ISO_8601, 'YYYY-MM-DD'], true);
    if (!parsedDob.isValid()) {
      this.signupForm.controls['birthDate'].setErrors({ 'incorrect': true });
      this.dateValidation = false;
      return;
    }

    this.signupForm.controls['birthDate'].setErrors(null);
    this.dateValidation = moment(moment().format('YYYY-MM-DD')).isBefore(parsedDob.format('YYYY-MM-DD'));

    // this.signupInput.birthDate = birthDate;
  }

  onBirthDateInput = (birthDate: any): void => {
    const formattedDate = this.autoFormatBirthDate(birthDate);
    this.signupInput.birthDate = formattedDate;
    this.signupForm.controls['birthDate'].setValue(formattedDate, { emitEvent: false });
    this.onDateChange(formattedDate);
  }

  saveMember = () => {
    this.errorMessage = "";

    this.submitted = true;

    if (this.signupForm.invalid) {
      return;
    }

    this.signupInput.parentId = (this.currentUser as any)?.id;


    if (this.type == 1 && this.signupInput.phoneNumberAll?.e164Number && this.signupInput.phoneNumberAll?.dialCode) {
      this.signupInput.phoneNumber = this.signupInput.phoneNumberAll.e164Number.replace(this.signupInput.phoneNumberAll.dialCode, "");
    }
    if (this.dateValidation) {
      return;
    }

    const serverBirthDate = this.toServerDate(this.signupInput.birthDate);
    if (this.global.isEmpty(serverBirthDate)) {
      this.signupForm.controls['birthDate'].setErrors({ 'incorrect': true });
      return;
    }
    this.signupInput.birthDate = serverBirthDate;

    this.signupInput.password = window.btoa(this.signupInput.userPassword || '');

    var d = new Date();
    var dateFormatStr = d.getFullYear().toString() + "-" + ((d.getMonth() + 1).toString().length == 2 ? (d.getMonth() + 1).toString() : "0" + (d.getMonth() + 1).toString()) + "-" + (d.getDate().toString().length == 2 ? d.getDate().toString() : "0" + d.getDate().toString()) + " " + (d.getHours().toString().length == 2 ? d.getHours().toString() : "0" + d.getHours().toString()) + ":" + ((parseInt((d.getMinutes() / 5).toString()) * 5).toString().length == 2 ? (parseInt((d.getMinutes() / 5).toString()) * 5).toString() : "0" + (parseInt((d.getMinutes() / 5).toString()) * 5).toString()) + ":00";

    //console.log("Signup Date: " + dateFormatStr);
    this.signupInput.signupTime = dateFormatStr;

    this.loader.show("Please wait...");
    this.authService.postEncrypt('user?' + this.requestPath + '=saveUserMember', this.signupInput)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res && res.success) {
          this.dismiss('ok');
        } else {
          this.errorMessage = res?.message || '';
        }
      }, (error: any) => {
        this.loader.hide();
        //console.log('Oops! Error occured while adding member. Please try again later.')
        this.errorMessage = 'Error occured, please try again.';
      });
  }

  togglePassword(id: string) {
    const password = document.querySelector('#' + id);
    if (password) {
      const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
      password.setAttribute('type', type);
    }
    if (id === 'pwd') {
      this.passwordVisible = !this.passwordVisible;
    }
  }

  onReset = () => {
    this.submitted = false;
    this.signupForm.reset();
  }

  // Phone number with country code field
  onCountryChange = (event: any) => {
    this.signupInput.phoneDialCode = this.signupInput.phoneNumberAll?.dialCode;
    this.signupInput.phoneCountryShortName = this.signupInput.phoneNumberAll?.countryCode;
  }

  private patchFormWithSignupInput = (): void => {
    this.signupForm.patchValue({
      firstName: this.signupInput.firstName || '',
      lastName: this.signupInput.lastName || '',
      emailAddress: this.signupInput.email || this.signupInput.emailAddress || '',
      role: this.signupInput.roleLevel || '',
      relation: this.signupInput.relationshipId || '',
      phoneNumber: this.mobileNoViewInEdit || this.getPhoneForEditView(this.signupInput),
      birthDate: this.signupInput.birthDate || ''
    }, { emitEvent: false });
  }

  private getPhoneForEditView = (user: RegUser): string => {
    const e164 = user?.phoneNumberAll?.e164Number;
    if (!this.global.isEmpty(e164)) {
      return e164;
    }

    const dialCode = user?.phoneDialCode || '';
    const phone = user?.phoneNumber || '';
    if (!this.global.isEmpty(phone)) {
      return (dialCode ? (dialCode + ' ') : '') + String(phone);
    }

    return '';
  }

  private formatBirthDateForDisplay = (birthDate: any): string => {
    if (this.global.isEmpty(birthDate)) {
      return '';
    }

    const parsed = moment(birthDate, [moment.ISO_8601, 'YYYY-MM-DD', 'MM/DD/YYYY'], true);
    return parsed.isValid() ? parsed.format('MM/DD/YYYY') : '';
  }

  private toServerDate = (birthDate: any): string => {
    if (this.global.isEmpty(birthDate)) {
      return '';
    }

    const parsed = moment(birthDate, ['MM/DD/YYYY', moment.ISO_8601, 'YYYY-MM-DD'], true);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
  }

  private autoFormatBirthDate = (value: any): string => {
    const digitsOnly = String(value || '').replace(/\D/g, '').slice(0, 8);

    if (digitsOnly.length <= 2) {
      return digitsOnly;
    }

    if (digitsOnly.length <= 4) {
      return digitsOnly.slice(0, 2) + '/' + digitsOnly.slice(2);
    }

    return digitsOnly.slice(0, 2) + '/' + digitsOnly.slice(2, 4) + '/' + digitsOnly.slice(4);
  }

}
